"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var ExclamationMarkTriangleIcon = function ExclamationMarkTriangleIcon(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? 'currentColor' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$filled = _ref.filled,
      filled = _ref$filled === void 0 ? false : _ref$filled,
      className = _ref.className,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["color", "size", "filled", "className", "children"]);

  var classes = 'calcite-icon';
  if (className) classes += " ".concat(className);

  if (size <= 16) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 16 16",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M14.894 12.552l-6-11.998a1 1 0 0 0-1.787 0l-6 11.998A.998.998 0 0 0 2 13.999h12a.998.998 0 0 0 .894-1.447zM9 12H7v-2h2zm0-3H7V4h2z"
    }) : _react["default"].createElement("path", {
      d: "M14.78 14.645L8.255 1.52a.938.938 0 0 0-.84-.52.938.938 0 0 0-.84.522L.092 14.647A.938.938 0 0 0 .932 16h13.009a.937.937 0 0 0 .838-1.355zm-.724.49a.137.137 0 0 1-.115.065H.933a.137.137 0 0 1-.116-.063.139.139 0 0 1-.008-.135L7.293 1.876a.14.14 0 0 1 .123-.076.138.138 0 0 1 .125.077l6.521 13.124a.138.138 0 0 1-.006.135zM7.495 11.5a.988.988 0 0 1 1 .976v.048a1 1 0 0 1-2 0v-.048a.988.988 0 0 1 1-.976zM7.018 6h.977v4h-.977z"
    }));
  }

  if (size <= 24) {
    return _react["default"].createElement("svg", _extends({}, props, {
      width: size,
      height: size,
      fill: color,
      viewBox: "0 0 24 24",
      className: classes
    }), filled ? _react["default"].createElement("path", {
      d: "M22.3 19.795l-9-17.901a1.5 1.5 0 0 0-2.597 0L1.7 19.795a1.502 1.502 0 0 0 0 1.502A1.456 1.456 0 0 0 2.998 22H21a1.458 1.458 0 0 0 1.299-.703 1.506 1.506 0 0 0 .001-1.502zM13 19h-2v-2h2zm0-3h-2V8h2z"
    }) : _react["default"].createElement("path", {
      d: "M23.767 20.569L13.995 2.827a1.745 1.745 0 0 0-2.969 0l-9.8 17.742a1.603 1.603 0 0 0 0 1.656 1.678 1.678 0 0 0 1.48.775H22.28a1.68 1.68 0 0 0 1.484-.775 1.609 1.609 0 0 0 .003-1.656zm-.861 1.143a.725.725 0 0 1-.626.288H2.708a.723.723 0 0 1-.623-.286.605.605 0 0 1-.001-.632l9.82-17.773A.71.71 0 0 1 12.508 3a.73.73 0 0 1 .629.342l9.751 17.708a.626.626 0 0 1 .017.662zM13 16h-1V9h1zm.5 2.5a1 1 0 1 1-1-1 1.002 1.002 0 0 1 1 1z"
    }));
  }

  return _react["default"].createElement("svg", _extends({}, props, {
    width: size,
    height: size,
    fill: color,
    viewBox: "0 0 32 32",
    className: classes
  }), filled ? _react["default"].createElement("path", {
    d: "M29.733 27.06L17.734 3.191a2 2 0 0 0-3.463 0L2.268 27.061a2.003 2.003 0 0 0 0 2.001 1.941 1.941 0 0 0 1.73.938H28a1.944 1.944 0 0 0 1.731-.938 2.008 2.008 0 0 0 .002-2.002zM17 25h-2v-2h2zm0-4h-2V11h2z"
  }) : _react["default"].createElement("path", {
    d: "M30.845 27.305L18.182 2.99a1.844 1.844 0 0 0-3.268-.005L2.158 27.3A1.844 1.844 0 0 0 3.79 30h25.42a1.844 1.844 0 0 0 1.635-2.695zm-.915 1.29a.847.847 0 0 1-.72.405H3.79a.843.843 0 0 1-.746-1.235L15.799 3.45a.843.843 0 0 1 1.495.001l12.664 24.315a.848.848 0 0 1-.028.828zM17.5 25.5a1 1 0 1 1-1-1 1.002 1.002 0 0 1 1 1zM17 22h-1V11h1z"
  }));
};

var _default = ExclamationMarkTriangleIcon;
exports["default"] = _default;